import { InnerBlocks, useBlockProps } from '@wordpress/block-editor';
import { __ } from '@wordpress/i18n';
import React from 'react';

interface SaveProps {
  attributes: {
    revealLabel: string;
    hideLabel: string;
    anchor?: string;
  };
}

const Save: React.FC<SaveProps> = ({ attributes: { revealLabel, hideLabel, anchor } }) => {
  // Generiere eine Content-ID basierend auf dem Anchor oder einem Fallback
  const contentId = anchor ? `${anchor}-content` : `revealer-content-${Math.floor(Math.random() * 10000)}`;

  return (
    <div
      {...useBlockProps.save({
        className: 'revealer',
        id: anchor
      })}
      x-data={`{
        open: false,
        revealLabel: '${revealLabel}',
        hideLabel: '${hideLabel}',
        buttonText() {
          return this.open ? this.hideLabel : this.revealLabel
        }
      }`}
    >
      <button
        className="revealer__button"
        aria-expanded="false"
        aria-controls={contentId}
        {...{
            "x-on:click": "open = !open",
            "x-bind:aria-expanded": "open.toString()",
            "x-html": "buttonText()"
        }}
      >
        {revealLabel}
      </button>
      <div
        id={contentId}
        className="revealer__content"
        {...{
            "x-bind:hidden": "!open",
            "x-bind:style": "{ display: open ? 'block' : 'none' }"
        }}
      >
        <InnerBlocks.Content />
      </div>
    </div>
  );
};

export default Save;
